<div
    [attr.data-sb-qa]="qaTag"
    class="sb-empty-state"
    [ngClass]="size">
    @let emptyStateHeight = size === EmptyStateSize.Large ? 240 : 128;
    @if (searchActive) {
        <lib-svg
            [src]="searchNoResultsFoundGraphic"
            [height]="emptyStateHeight"
            alt=""></lib-svg>
    } @else {
        <lib-svg
            [src]="emptyStateGraphic"
            [height]="emptyStateHeight"
            alt=""></lib-svg>
    }
    <div class="sb-empty-state-content-wrapper">
        <div class="sb-empty-state-text-wrapper">
            <h3>
                <ng-content select="[emptyStateText]"></ng-content>
            </h3>
            <p>
                <ng-content select="[emptyStateDescription]"></ng-content>
            </p>
        </div>
        @if (!searchActive) {
            <lib-button-group 
                [orientation]="(isMobile || size === EmptyStateSize.Medium) 
                ? Orientation.Vertical 
                : Orientation.Horizontal">
                <ng-content select="[emptyStateButton]"></ng-content>
            </lib-button-group>
        } @else {
            <lib-button-group>
                <lib-button
                    [kind]="ButtonKind.Secondary"
                    (clicked)="ClearSearchClicked()">
                    <ng-container
                        label
                        i18n="@@CommonEmptyStateClearSearchLabel">
                        Clear Search
                    </ng-container>
                </lib-button>
            </lib-button-group>
        }
    </div>
</div>
